import { AfterViewInit, Component, ComponentFactoryResolver, Input } from "@angular/core";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'reporteevaluacionpendientepreguntaenviadadetalle_pregunta',
        templateUrl: './preguntaenviadadetalle_pregunta.component.html',
        styleUrls: ['./preguntaenviadadetalle_pregunta.component.scss']
    })

export class ReporteEvaluacionPendientePreguntaEnviadaDetallePreguntaComponent implements AfterViewInit{
    @Input() entidad!: any;
    @Input() accion!: any;
    @Input() listapreguntas!:any;

    consulta!:boolean;
    public abierto!: boolean;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
        this.abierto = true;
        this.buscarpreguntas();
    }

    buscarpreguntas(){
        this.listapreguntas.map((pregunta: any) => {
            pregunta.colortext = this.cambiarcolor(pregunta.color);
        })

    }

    cambiarcolor(color: any): string {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        let val: any = [];
        if (result) {
            let r = parseInt(result[1], 16)
            let g = parseInt(result[2], 16)
            let b = parseInt(result[3], 16)
            val = this.rgbToHsl(r, g, b);
        }
        if (val[2] < 50) {
            return "colorblanco"
        } else {

            return "colornegro";
        }
    }

    rgbToHsl(r: any, g: any, b: any) {
        r /= 255;
        g /= 255;
        b /= 255;

        // Find greatest and smallest channel values
        let cmin = Math.min(r, g, b),
            cmax = Math.max(r, g, b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

        // Calculate hue
        // No difference
        if (delta == 0)
            h = 0;
        // Red is max
        else if (cmax == r)
            h = ((g - b) / delta) % 6;
        // Green is max
        else if (cmax == g)
            h = (b - r) / delta + 2;
        // Blue is max
        else
            h = (r - g) / delta + 4;

        h = Math.round(h * 60);

        // Make negative hues positive behind 360°
        if (h < 0)
            h += 360;

        // Calculate lightness
        l = (cmax + cmin) / 2;

        // Calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // Multiply l and s by 100
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);

        return [h, s, l];
    }

}